import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import moment from 'moment';
import MenuHogarSSV from './MenuHogarSSV';
function CalcularEdad(date){
    return moment().diff(date, 'years');
}
export default function SSVAlimentacion() {
    const { token } = useAuth();
    const { idEncuesta } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [nombreJefe, setNombreJefe] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idEncuesta) => {
        let url = `/encuestassv/hogar/crearformularioalimentacion`;
        let obj = { idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.alimentacion);
            setNombreJefe(result.jefeHogar.nombre || '');

            console.log('Datos de alimentación obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos de alimentación de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
    
    useEffect(() => {
        fetchData( idEncuesta);
    }, [idEncuesta]);    

    async function GuardarDatosAlimentacion() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/hogar/guardardatosalimentacion`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de alimentación de la persona.');
            }
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de alimentación de la persona. ' + (error.message || ''));
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }

    const resetForm = (data) => {
        try {
            if (data) {
                reset((prevValues) => ({
                    ...prevValues,
                    id: data.id || '',
                    fichaid: data.fichaid || '',
                    alim_consumo_leguminosas: data.alim_consumo_leguminosas || '',
                    alim_consumo_leguminosas_cuantos: data.alim_consumo_leguminosas_cuantos || '',
                    alim_consumo_cereal: data.alim_consumo_cereal || '',
                    alim_consumo_cereal_cuantos: data.alim_consumo_cereal_cuantos || '',
                    alim_consumo_tuberculos: data.alim_consumo_tuberculos || '',
                    alim_consumo_tuberculos_cuantos: data.alim_consumo_tuberculos_cuantos || '',
                    alim_consumo_verduras: data.alim_consumo_verduras || '',
                    alim_consumo_verduras_cuantos: data.alim_consumo_verduras_cuantos || '',
                    alim_consumo_frutas: data.alim_consumo_frutas || '',
                    alim_consumo_frutas_cuantos: data.alim_consumo_frutas_cuantos || '',
                    alim_consumo_carnes: data.alim_consumo_carnes || '',
                    alim_consumo_carnes_cuantos: data.alim_consumo_carnes_cuantos || '',
                    alim_consumo_huevo: data.alim_consumo_huevo || '',
                    alim_consumo_huevo_cuantos: data.alim_consumo_huevo_cuantos || '',
                    alim_consumo_lacteos: data.alim_consumo_lacteos || '',
                    alim_consumo_lacteos_cuantos: data.alim_consumo_lacteos_cuantos || '',
                    alim_consumo_grasas: data.alim_consumo_grasas || '',
                    alim_consumo_grasas_cuantos: data.alim_consumo_grasas_cuantos || '',
                    alim_consumo_azucar: data.alim_consumo_azucar || '',
                    alim_consumo_azucar_cuantos: data.alim_consumo_azucar_cuantos || '',
                    alim_consumo_bienestarina: data.alim_consumo_bienestarina || '',
                    alim_consumo_bienestarina_cuantos: data.alim_consumo_bienestarina_cuantos || '',
                    alim_3_preocupo_alimentos: data.alim_3_preocupo_alimentos || '',
                    alim_4_agotaron_alimentos: data.alim_4_agotaron_alimentos || '',
                    alim_5_no_pudo_variar_alimentos_saludables: data.alim_5_no_pudo_variar_alimentos_saludables || '',
                    alim_6_adulto_comio_menos_de_lo_habitual_por_falta_dinero: data.alim_6_adulto_comio_menos_de_lo_habitual_por_falta_dinero || '',
                    alim_7_adulto_no_comio_por_falta_dinero: data.alim_7_adulto_no_comio_por_falta_dinero || '',
                    alim_8_adulto_comio_solo_una_vez_por_falta_dinero: data.alim_8_adulto_comio_solo_una_vez_por_falta_dinero || '',
                    alim_9_adulto_sintio_ambre_no_comio_por_falta_dinero: data.alim_9_adulto_sintio_ambre_no_comio_por_falta_dinero || '',
                    alim_10_adulto_dejo_de_comer_todo_dia: data.alim_10_adulto_dejo_de_comer_todo_dia || '',
                    alim_11_adulto_acosto_con_hambre: data.alim_11_adulto_acosto_con_hambre || '',
                    alim_12_menor_no_tuvo_alim_saludable_por_falta_dinero: data.alim_12_menor_no_tuvo_alim_saludable_por_falta_dinero || '',
                    alim_13_menor_tuvo_alim_poca_variedad_por_falta_dinero: data.alim_13_menor_tuvo_alim_poca_variedad_por_falta_dinero || '',
                    alim_14_tuvo_disminuir_comida_menor_por_falta_dinero: data.alim_14_tuvo_disminuir_comida_menor_por_falta_dinero || '',
                    alim_15_menor_sintio_hambre_no_comio_por_falta_dinero: data.alim_15_menor_sintio_hambre_no_comio_por_falta_dinero || '',
                    alim_16_menor_no_comio_por_falta_dinero: data.alim_16_menor_no_comio_por_falta_dinero || '',
                    alim_17_comio_solo_1_vez_por_falta_dinero: data.alim_17_comio_solo_1_vez_por_falta_dinero || '',
                    alim_observacion: data.alim_observacion || '',
                }))
            }
        } catch (error) {
            console.error('Error al resetear el formulario:', error);
        }
    }
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Alimentaci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Alimentaci&oacute;n</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">                
                <div className="container-fluid">
                    <Form onSubmit={handleSubmit(GuardarDatosAlimentacion)}>
                            <Card>
                            <Card.Header>
                                <h3 className="box-title"><b>G. ALIMENTACI&Oacute;N - {getValues("id")}</b></h3>
                                <p>(para el[la] jefe[a] del hogar o su conyugue). - {nombreJefe}</p>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                        <Form.Label htmlFor="txtpuntajepca">Puntaje PCA</Form.Label>
                                        <Form.Control readOnly id="txtpuntajepca" type="text" />
                                        </div>  
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                        <Form.Label htmlFor="txtdescripcionpca">Descripcion PCA</Form.Label>
                                        <Form.Control readOnly id="txtdescripcionpca" type="text" />
                                        </div>  
                                    </Col>
                                </Row>  
                            </Card.Body>
                            <Card.Body>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>1. ¿En los últimos siete días, contando  el día de ayer, este hogar consumió ...?</Form.Label>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>a. Leguminosas (fríjol, lentejas, garbanzos, arvejas)</Form.Label>
                                    <Form.Control as="select" id="alim_consumo_leguminosas" style={{width: "100%"}}  {...register('alim_consumo_leguminosas')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divleguminosascuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_leguminosas_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_leguminosas_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>b. Cereales (arroz, maíz, pan, avena, arepa)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_cereal" style={{width: "100%"}} {...register('alim_consumo_cereal')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control> 
                                </Col>
                                <Col md={6} id="divcerealcuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_cereal_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_cereal_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>c. Tubérculos y plátanos (yuca, ñame, arracacha, plátano, papa)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_tuberculos" style={{width: "100%"}} {...register('alim_consumo_tuberculos')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control> 
                                </Col>
                                <Col md={6} id="divtuberculoscuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_tuberculos_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_tuberculos_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>d. Verduras y hortalizas (tomate, cebolla, ahuyama habichuela, zanahoria, espinaca)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_verduras" style={{width: "100%"}} {...register('alim_consumo_verduras')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control> 
                                </Col>
                                <Col md={6} id="divverdurascuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_verduras_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_verduras_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>e. Frutas (papaya, guayaba, piña, etc.)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_frutas" style={{width: "100%"}} {...register('alim_consumo_frutas')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divfrutascuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_frutas_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_frutas_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>f. Carnes (pescado, res, pollo, cerdo, cabra)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_carnes" style={{width: "100%"}} {...register('alim_consumo_carnes')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divcarnescuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_carnes_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_carnes_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>g. Huevo</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_huevo" style={{width: "100%"}} {...register('alim_consumo_huevo')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divhuevocuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_huevo_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_huevo_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>h. Lácteos (leche, queso, yogurt)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_lacteos" style={{width: "100%"}} {...register('alim_consumo_lacteos')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divlacteoscuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_lacteos_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_lacteos_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>i. Grasas (aceites, mantequilla, margarina, mayonesa, manteca, etc.)</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_grasas" style={{width: "100%"}} {...register('alim_consumo_grasas')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divgrasascuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_grasas_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_grasas_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>j. Azúcar o panela</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_azucar" style={{width: "100%"}} {...register('alim_consumo_azucar')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divazucarcuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_azucar_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_azucar_cuantos')} />Pase al siguiente grupo de alimentos
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <Form.Label>k. Bienestarina</Form.Label> 
                                    <Form.Control as="select" id="alim_consumo_bienestarina" style={{width: "100%"}} {...register('alim_consumo_bienestarina')} >
                                    <option value='0'  ></option>
                                    <option value='1'>1. Si</option>
                                    <option value='2'>2. No</option>
                                    </Form.Control>
                                </Col>
                                <Col md={6} id="divbienestarinacuantosdias">
                                    <Form.Label>2. ¿Cuántos días?</Form.Label> 
                                    <Form.Control style={{width: "120px"}} id="alim_consumo_bienestarina_cuantos" type="text" placeholder="Dias" maxLength="1" {...register('alim_consumo_bienestarina_cuantos')} />Pase a la pregunta 3
                                </Col>
                                </Row>
                            </Card.Body>
                            <Card.Body>
                                <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                    <Form.Label htmlFor="txtpuntajeelcsa">Puntaje ELCSA</Form.Label>
                                    <Form.Control readOnly id="txtpuntajeelcsa" type="text" />
                                    </div>  
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                    <Form.Label htmlFor="txtdescripcionelcsa">Descripcion ELCSA</Form.Label>
                                    <Form.Control readOnly id="txtdescripcionelcsa" type="text" />
                                    </div>  
                                </Col>
                                </Row>
                            </Card.Body>
                            <Card.Body>
                                <Row>
                                <Col md={6}>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>3. En los últimos 30 días, ¿Usted se preocupó alguna vez de que en su hogar se acabaran los alimentos debido a falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_3_preocupo_alimentos" style={{width: "100%"}} {...register('alim_3_preocupo_alimentos')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>4. En los últimos 30 días, ¿Alguna vez en su hogar se quedaron sin dinero para una alimentación nutritiva: es decir que contenga carne, leche o productos lácteos, frutas, huevos, cereales, leguminosas, tubérculos y platanos?</Form.Label>
                                        <Form.Control as="select" id="alim_4_agotaron_alimentos" style={{width: "100%"}} {...register('alim_4_agotaron_alimentos')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>5. En los últimos 30 días, ¿Alguna vez usted o algún adulto de su hogar no pudo variar la alimentación por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_5_no_pudo_variar_alimentos_saludables" style={{width: "100%"}} {...register('alim_5_no_pudo_variar_alimentos_saludables')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>6. En los últimos 30 días, ¿Alguna vez usted o algún adulto de su hogar comió menos de lo que está acostrubrado por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_6_adulto_comio_menos_de_lo_habitual_por_falta_dinero" style={{width: "100%"}} {...register('alim_6_adulto_comio_menos_de_lo_habitual_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>7. En los últimos 30 días, ¿ Alguna vez en su hogar se quedaron sin alimentos por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_7_adulto_no_comio_por_falta_dinero" style={{width: "100%"}} {...register('alim_7_adulto_no_comio_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                </Col>
                                <Col md={6}>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>8. En los últimos 30 días, ¿Alguna vez usted o algún adulto de su hogar dejó de desayunar, almorzar o comer por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_8_adulto_comio_solo_una_vez_por_falta_dinero" style={{width: "100%"}} {...register('alim_8_adulto_comio_solo_una_vez_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>   
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>9. En los últimos 30 días, ¿Alguna vez usted o algún adulto de su hogar sintió o se quejó de hambre y no comió por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_9_adulto_sintio_ambre_no_comio_por_falta_dinero" style={{width: "100%"}} {...register('alim_9_adulto_sintio_ambre_no_comio_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>10. En los últimos 30 días, ¿Alguna vez usted o algún adulto de su hogar solo comió una sola vez al día o dejó de comer en todo un día por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_10_adulto_dejo_de_comer_todo_dia" style={{width: "100%"}} {...register('alim_10_adulto_dejo_de_comer_todo_dia')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>11. En los últimos 30 días, ¿Alguna vez, algún adulto de su hogar se acostó con hambre porque no alcanzó el dinero para los alimentos?</Form.Label>
                                        <Form.Control as="select" id="alim_11_adulto_acosto_con_hambre" style={{width: "100%"}} {...register('alim_11_adulto_acosto_con_hambre')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                </Col>
                                <hr width="75%" style={{borderColor: "#73ACE8"}} />
                                <Col md={6}>
                                    <Col md={12}>
                                    <Form.Label style={{fontStyle: "italic"}}>A partir de acá hasta la pregunta 17, aplica sólo para menores de 18 años de edad</Form.Label>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>12. En los últimos 30 días, ¿Alguna vez por falta de dinero algún niño o joven de su hogar dejo de tener una alimentacion nutritiva, es decir que contenga carne, leche, frutas, verduras, cereales, leguminosas, tubérculos y plátanos?</Form.Label>
                                        <Form.Control as="select" id="alim_12_menor_no_tuvo_alim_saludable_por_falta_dinero" style={{width: "100%"}} {...register('alim_12_menor_no_tuvo_alim_saludable_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>   
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>13. En los ùltimos 30 dìas, ¿Alguna vez algún niño o joven de su hogar no pudo variar la alimentacion por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_13_menor_tuvo_alim_poca_variedad_por_falta_dinero" style={{width: "100%"}} {...register('alim_13_menor_tuvo_alim_poca_variedad_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>14. En los últimos 30 dias, ¿Alguna vez usted tuvo que disminuir la cantidad servida en las comidas de algún niño o joven de su hogar, por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_14_tuvo_disminuir_comida_menor_por_falta_dinero" style={{width: "100%"}} {...register('alim_14_tuvo_disminuir_comida_menor_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>   
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>15. En los últimos 30 dias, ¿Alguna vez, algún niño o joven de su hogar se quejó de hambre y no se pudo comprar más alimentos por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_15_menor_sintio_hambre_no_comio_por_falta_dinero" style={{width: "100%"}} {...register('alim_15_menor_sintio_hambre_no_comio_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div> 
                                    </Col>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>16. En los últimos 30 dias, ¿Alguna vez, algún niño o joven de su hogar se acostó con hambre por que no alcanzo el dinero para los alimentos?</Form.Label>
                                        <Form.Control as="select" id="alim_16_menor_no_comio_por_falta_dinero" style={{width: "100%"}} {...register('alim_16_menor_no_comio_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div>  
                                    </Col>
                                </Col>
                                <Col md={6}>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label>17. En los últimos 30 dias, ¿Alguna vez, algún niño o joven de su hogar solo comió una vez al día o dejó de comer todo un dia por falta de dinero?</Form.Label>
                                        <Form.Control as="select" id="alim_17_comio_solo_1_vez_por_falta_dinero" style={{width: "100%"}} {...register('alim_17_comio_solo_1_vez_por_falta_dinero')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        </Form.Control>
                                    </div> 
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                        <Form.Label>Observaciones</Form.Label>
                                        <Form.Control as="textarea" id="alim_observacion" className="form-control" rows="12" placeholder="Observaciones" {...register('alim_observacion')}></Form.Control>
                                        </div>  
                                    </Col>
                                </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <Row>
                                    <Col md={12}>
                                        <button type="submit" className="btn btn-block btn-primary btn-sm" id="btnupdateAlimentos2">Actualizar</button>  
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card> 
                    </Form>
                    <MenuHogarSSV idEncuesta={idEncuesta} />
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }